import React from "react";
import termsMd from "../data/termsOfService";

export default function TermsPage() {
  return (
    <main>
      {/* Hero */}
      <section className="relative h-60 w-full overflow-hidden md:h-80">
        {/* <img
          src="/legal/aszf_hero.jpg"
          alt="Általános szerződési feltételek"
          className="absolute inset-0 h-full w-full object-cover"
        /> */}
        <div className="absolute inset-0 bg-black/50" />
        <h1 className="relative z-10 flex h-full items-center justify-center text-3xl font-bold text-white md:text-4xl">
          Általános Szerződési Feltételek
        </h1>
      </section>

      <article className="prose mx-auto max-w-4xl px-4 py-12 prose-h2:text-primary prose-a:text-primary">
        <p className="whitespace-pre-line">{termsMd}</p>
      </article>

      <p className="mb-20 text-center text-sm text-gray-600">
        A dokumentum PDF formátumban is letölthető:{" "}
        <a href="/legal/aszf.pdf" download className="text-primary underline">
          aszf.pdf
        </a>
      </p>
    </main>
  );
}
